/*
 * BIT attribution + click_whatsapp (Fase 1).
 * Regra (ADR-001): first-touch nunca é sobrescrito (TTL 90d); last-touch é
 * atualizado a cada chegada com parâmetro de campanha. Ambos vão para cart
 * attributes com prefixo "_" (ocultos no checkout) e chegam ao pedido.
 * click_whatsapp é informativo: dataLayer + Shopify.analytics.publish, nunca conversão.
 * Meta: cookies _fbp/_fbc vão para _bit_fbp/_bit_fbc (lidos pela CAPI). Sem _fbc,
 * monta fb.1.<ms>.<fbclid> da URL. Nunca envia valor vazio; rechecha porque o
 * pixel pode criar o _fbp depois do carregamento.
 * GA4 (Measurement Protocol): _ga "GA1.1.X.Y" -> _bit_ga_cid "X.Y"; _ga_<ID> -> _bit_ga_sid (session_id).
 * Também nunca envia vazio e rechecha (o gtag cria os cookies depois do load).
 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.BitAttribution = api;
})(typeof self !== 'undefined' ? self : this, function () {
  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'gbraid', 'wbraid', 'fbclid'];
  var STORE_KEY = 'bit_attr_v1';
  var TTL_MS = 90 * 24 * 60 * 60 * 1000;
  var DEDUP_MS = 1500;

  function parseTouch(href, referrer, now) {
    var url = new URL(href);
    var touch = {};
    KEYS.forEach(function (k) {
      var v = url.searchParams.get(k);
      if (v) touch[k] = v.slice(0, 200);
    });
    if (!Object.keys(touch).length) return null;
    touch.landing_page = (url.origin + url.pathname).slice(0, 255);
    touch.referrer = (referrer || '').slice(0, 255);
    touch.ts = new Date(now).toISOString();
    return touch;
  }

  function merge(state, touch, now) {
    var s = state && state.ft && now - Date.parse(state.ft.ts) < TTL_MS ? state : {};
    if (!touch) return { state: s, changed: false };
    return { state: { ft: s.ft || touch, lt: touch }, changed: true };
  }

  function toCartAttributes(state) {
    var out = {};
    ['ft', 'lt'].forEach(function (p) {
      var t = state[p];
      if (!t) return;
      Object.keys(t).forEach(function (k) { out['_bit_' + p + '_' + k] = t[k]; });
    });
    return out;
  }

  function readCookie(cookieStr, name) {
    var m = ('; ' + (cookieStr || '')).match(new RegExp('; ' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  function metaAttributes(cookieStr, href, now) {
    var out = {};
    var fbp = readCookie(cookieStr, '_fbp');
    var fbc = readCookie(cookieStr, '_fbc');
    if (!fbc) {
      var fbclid = new URL(href).searchParams.get('fbclid');
      if (fbclid) fbc = 'fb.1.' + now + '.' + fbclid;
    }
    if (fbp) out._bit_fbp = fbp.slice(0, 255);
    if (fbc) out._bit_fbc = fbc.slice(0, 500);
    return out;
  }

  var GA_MEASUREMENT_ID = 'G-YHVTNP5YCF';

  // _ga = "GA1.<n>.<client_id parte 1>.<parte 2>" -> "<p1>.<p2>"
  function parseGaClientId(v) {
    var m = /^GA\d+\.\d+\.(\d+\.\d+)$/.exec(v || '');
    return m ? m[1] : '';
  }

  // _ga_<ID>: formato GS1 "GS1.1.<sid>.<n>.<...>" ou GS2 "GS2.1.s<sid>$o<n>$g..."
  function parseGaSessionId(v) {
    var m = /^GS1\.\d+\.(\d{9,12})\./.exec(v || '') || /^GS2\.\d+\.s(\d{9,12})(?:\$|$)/.exec(v || '');
    return m ? m[1] : '';
  }

  function gaAttributes(cookieStr, measurementId) {
    var out = {};
    var cid = parseGaClientId(readCookie(cookieStr, '_ga'));
    var sid = parseGaSessionId(readCookie(cookieStr, '_ga_' + String(measurementId || GA_MEASUREMENT_ID).replace(/^G-/, '')));
    if (cid) out._bit_ga_cid = cid;
    if (sid) out._bit_ga_sid = sid;
    return out;
  }

  function isWhatsAppHref(href) {
    return /^(https?:\/\/)?(wa\.me|api\.whatsapp\.com|web\.whatsapp\.com)\//i.test(href || '') || /^whatsapp:/i.test(href || '');
  }

  // Alvos de WhatsApp: link direto (wa.me/api) ou envio válido do formulário RD
  // cuja ação é abrir o WhatsApp. Abrir/fechar o widget RD não conta (é só toggle).
  var RD_FORM = 'form.rdstation-popup-js-form-identifier';
  var RD_SUBMIT = '.rdstation-popup-js-submit-button';

  function decodeBase64(b64) {
    var clean = String(b64 || '').replace(/\s+/g, '');
    if (typeof atob === 'function') return atob(clean);
    return Buffer.from(clean, 'base64').toString('utf8');
  }

  function isRdWhatsAppForm(form) {
    try {
      return JSON.parse(decodeBase64(form.getAttribute('data-popup-action'))).type === 'whatsapp';
    } catch (e) { return false; }
  }

  function classifyWhatsAppTarget(el) {
    if (!el || !el.closest) return null;
    var a = el.closest('a[href]');
    if (a && isWhatsAppHref(a.getAttribute('href'))) {
      return { key: a.getAttribute('href'), source: a.getAttribute('data-wa-source') || 'link' };
    }
    var form = el.closest(RD_SUBMIT) && el.closest(RD_FORM);
    if (form && isRdWhatsAppForm(form) && (!form.checkValidity || form.checkValidity())) {
      var ci = form.querySelector && form.querySelector('input[name="conversion_identifier"]');
      return { key: 'rd_whatsapp_form', source: 'rd_whatsapp_form', once: true,
        conversionIdentifier: ci ? ci.value : undefined };
    }
    return null;
  }

  function buildWhatsAppEvent(ctx, state) {
    var lt = (state && state.lt) || {};
    return {
      event: 'click_whatsapp',
      event_category: 'informational',
      page_location: ctx.href,
      page_path: ctx.path,
      product_id: ctx.productId || undefined,
      product_title: ctx.productTitle || undefined,
      product_variant: ctx.variantId || undefined,
      source: ctx.source || 'link',
      rd_conversion_identifier: ctx.conversionIdentifier || undefined,
      template: ctx.template || undefined,
      utm_source: lt.utm_source, utm_medium: lt.utm_medium, utm_campaign: lt.utm_campaign,
      click_ts: new Date(ctx.now).toISOString()
    };
  }

  // once=true: no máximo um evento por pageview para a chave.
  function createDeduper(windowMs) {
    var last = {};
    return function (key, now, once) {
      if (last[key] && (once || now - last[key] < windowMs)) return false;
      last[key] = now;
      return true;
    };
  }

  function readState(storage) {
    try { return JSON.parse(storage.getItem(STORE_KEY)) || {}; } catch (e) { return {}; }
  }
  function writeState(storage, s) {
    try { storage.setItem(STORE_KEY, JSON.stringify(s)); } catch (e) { /* storage bloqueado */ }
  }

  function init(win) {
    var doc = win.document;
    var now = Date.now();
    var res = merge(readState(win.localStorage), parseTouch(win.location.href, doc.referrer, now), now);
    writeState(win.localStorage, res.state);
    var touchAttrs = toCartAttributes(res.state);
    var meta = Object.assign({}, metaAttributes(doc.cookie, win.location.href, now), gaAttributes(doc.cookie));
    function sync() {
      var m = Object.assign({}, metaAttributes(doc.cookie, win.location.href, now), gaAttributes(doc.cookie));
      if (!m._bit_fbc && meta._bit_fbc) m._bit_fbc = meta._bit_fbc; // fbc montado do fbclid fica estável na página
      meta = m;
      var attrs = Object.assign({}, touchAttrs, meta);
      var sig = JSON.stringify(attrs);
      var synced = null;
      try { synced = win.sessionStorage.getItem('bit_attr_synced'); } catch (e) {}
      if (!Object.keys(attrs).length || sig === synced || !win.fetch) return;
      win.fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).then(function (r) {
        if (r.ok) try { win.sessionStorage.setItem('bit_attr_synced', sig); } catch (e) {}
      }).catch(function () {});
    }
    sync();
    [2000, 5000, 10000].forEach(function (ms) { win.setTimeout(sync, ms); });
    doc.addEventListener('submit', sync, true); // add-to-cart

    var allow = createDeduper(DEDUP_MS);
    doc.addEventListener('click', function (e) {
      var target = classifyWhatsAppTarget(e.target);
      if (!target) return;
      var t = Date.now();
      if (!allow(target.key, t, target.once)) return;
      var meta = win.BIT_PAGE || {};
      var payload = buildWhatsAppEvent({
        href: win.location.href, path: win.location.pathname, now: t,
        template: meta.source, productId: meta.productId, productTitle: meta.productTitle, variantId: meta.variantId,
        source: target.source, conversionIdentifier: target.conversionIdentifier
      }, readState(win.localStorage));
      win.dataLayer = win.dataLayer || [];
      win.dataLayer.push(payload);
      if (/[?&]bit_debug=1/.test(win.location.search)) win.console.info('[bit] click_whatsapp', payload);
      // Customer Events: disponível para Custom Pixel via analytics.subscribe('click_whatsapp')
      try { win.Shopify.analytics.publish('click_whatsapp', payload); } catch (err) {}
    }, true);
  }

  if (typeof window !== 'undefined' && window.document) init(window);

  return { parseTouch: parseTouch, merge: merge, toCartAttributes: toCartAttributes, metaAttributes: metaAttributes, gaAttributes: gaAttributes, parseGaClientId: parseGaClientId, parseGaSessionId: parseGaSessionId,
    isWhatsAppHref: isWhatsAppHref, classifyWhatsAppTarget: classifyWhatsAppTarget, isRdWhatsAppForm: isRdWhatsAppForm, buildWhatsAppEvent: buildWhatsAppEvent, createDeduper: createDeduper,
    TTL_MS: TTL_MS };
});